import styled from 'styled-components'
import CompareCta from 'Components/CompareCta'

import { BREAK_POINT_LG } from '@CSSVars/variables'
import { OUTLINE_COLOR, TEXT_GREY } from '@CSSVars/colors'


export const _CardFooter = styled.div`
  width: 100%;
  padding: 12px 0;
  border-top: 1px solid ${OUTLINE_COLOR};
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none;
  }
`

export const _CompareCta = styled(CompareCta)`
  height: 22px;
  font-size: 12px;
  padding: 0 12px;
`

export const _ListedDays = styled.div`
  font-size: 12px;
  padding-right: 10px;
  color: ${TEXT_GREY};
`
